import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/Computer_Vision_new.mp4";
import videoSource1 from "../../assets/videos/Computer_Vision_Demo.mp4";
import comvision from "../../assets/images/resource/Computer_Vision.png";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/azure-ai.png";
import cv from "./../../assets/images/icons/cv.jpg";
import msa from "./../../assets/images/icons/msa.png";

const ComputerVision = () => {
  pageTitle("Computer Vision");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${SorBanner})` }}
      >
        {/* <img src={SorBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          <img
            src={msa}
            alt="Microsoft azure"
            className="ai-overlay-corner-img"
          />
          <div className="ai-overlay-center-text">
            <h2 className="aai-h2">Azure AI Image Analysis</h2>
            <p>
              <img src={cv} alt="Microsoft azure" style={{ height: "30px" }} />{" "}
              Computer Vision
            </p>
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                Turn uploaded images into structured insights with an automated
                Microsoft Azure workflow.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                This solution transforms uploaded files and images into
                structured, accessible data through an intelligent processing
                workflow:
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Six-Step Workflow
              </p>
              <ol>
                <li>Upload – User submits an image or file for processing.</li>
                <li>
                  Trigger – The upload event automatically activates the
                  workflow.
                </li>
                <li>
                  Process – A serverless function manages and orchestrates the
                  processing pipeline.
                </li>
                <li>
                  Analyze – The Computer Vision API extracts insights, text, and
                  metadata from the file.
                </li>
                <li>
                  Store – The processed results are saved in a structured
                  database for future use.
                </li>
                <li>
                  Access – The data is made available to web and mobile
                  applications for easy access.
                </li>
              </ol>
            </div>
          </div>

          <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated Azure AI Services.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the <strong>Azure AI Image Analysis</strong>
              ,
              <br />
              Click 👉{" "}
              <a
                href="https://ai.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Azure AI Computer Vision
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px" }}>
        <div className="siw-rpa-desc mt-0">
          <h3>Architecture</h3>
          <p className="pt-2">
            This architectural diagram illustrates an automated workflow for
            image analysis using Microsoft Azure's cloud services. The process
            begins when a user uploads a file, which acts as an event trigger to
            notify a serverless function that new data is available. This
            central processor then communicates with a Computer Vision API to
            extract meaningful insights and descriptive metadata from the visual
            content. Finally, the system preserves these results in a structured
            database, allowing the processed information to be seamlessly
            accessed by various web or mobile applications.
          </p>
          <img
            src={comvision}
            alt="Computer Vision"
            className="siw-rpa-desc-img"
          />
        </div>
      </div>

      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing Azure AI Image Analysis
              </h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the <strong>Azure AI Image Analysis</strong>,
            Click 👉{" "}
            <a
              href="https://ai.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Azure AI Computer Vision
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default ComputerVision;
